const getExchangeItems = (orderId, orderItemId, identifier, overviewPath, itemPath) => [
  {
    id: 1,
    label: I18n.t('components.flight.exchange.previous_item.order'),
    text: `#${orderId}`,
    href: overviewPath,
  },
  {
    id: 2,
    label: I18n.t('components.flight.exchange.previous_item.item'),
    text: `#${orderItemId}`,
    href: itemPath,
  },
  { id: 3, label: I18n.t('components.flight.exchange.previous_item.pnr'), text: identifier },
];

export default getExchangeItems;
